class WatchSlide extends HTMLElement {
  constructor () {
    super()

    this.wrapperEl = this.querySelector('[data-el="watch-slide.wrapper"]')
    this.dayWatchEl = this.querySelector('[data-el="watch-slide.day-watch"]')
    this.scrollerEl = this.querySelector('[data-el="watch-slide.scroller"]')

    this.active = false

    this.setupSlider()
    this.setupListeners()
  }

  setupListeners () {
    this.resetSliderPosition = this.resetSliderPosition.bind(this)
    window.addEventListener('resize', this.resetSliderPosition)
  }

  setupSlider () {
    this.scrollerEl.addEventListener(
      'mousedown',
      this.handleAddClass.bind(this)
    )

    document.body.addEventListener('mouseup', this.handleRemoveClass.bind(this))

    document.body.addEventListener(
      'mouseleave',
      this.handleRemoveClass.bind(this)
    )

    document.body.addEventListener('mousemove', this.handleMouseMove.bind(this))

    const wrapperElWidth = this.wrapperEl.offsetWidth
    this.scrollIt(wrapperElWidth / 2)

    this.scrollerEl.addEventListener(
      'touchstart',
      this.handleAddClass.bind(this)
    )

    document.body.addEventListener('touchmove', this.handleTouchMove.bind(this))

    document.body.addEventListener(
      'touchend',
      this.handleRemoveClass.bind(this)
    )
  }

  resetSliderPosition () {
    const wrapperElWidth = this.wrapperEl.offsetWidth
    this.scrollIt(wrapperElWidth / 2)
  }

  handleAddClass = event => {
    this.active = true
    this.scrollerEl.classList.add('sec-TextWatch_Scroller-scrolling')
  }

  handleRemoveClass = event => {
    this.active = false
    this.scrollerEl.classList.remove('sec-TextWatch_Scroller-scrolling')
  }

  handleMouseMove = event => {
    if (!this.active) return

    let x = event.pageX

    x -= this.wrapperEl.getBoundingClientRect().left

    this.scrollIt(x)
  }

  scrollIt (x) {
    const transform = Math.max(0, Math.min(x, this.wrapperEl.offsetWidth))

    this.dayWatchEl.style.width = `${transform}px`
    this.scrollerEl.style.left = `${transform - 30}px`
  }

  handleTouchMove = event => {
    if (!this.active) return

    let x = event.changedTouches[0].pageX

    x -= this.wrapperEl.getBoundingClientRect().left

    this.scrollIt(x)
  }
}

customElements.define('watch-slide', WatchSlide)
